import {
    Backdrop,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormHelperText,
    InputLabel,
    makeStyles,
    Typography,
} from "@material-ui/core";
import Config from "Config";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import sysend from "sysend";
import iamsmartIconDark from "../../images/iamsmart-icon-dark.png";
import iamSmartPhone from "../../images/icon-dark.png";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import {
    getIamsmartProfileDone,
    setToken,
    setUserRole,
} from "../../redux/action";
import ErrorMsg from "../ErrorMsg/ErrorMsg";

import jwtDecode from "jwt-decode";
import { getIamsmart, getIamsmartProfile } from "../../redux/selector";
import { send, sendV20 } from "../../SendRequest";
import { getIamsmartAppUrl, isIOS, isNotEmpty } from "../../Utils";
import LinkUpDialog from "../LinkUpDialog/LinkUpDialog";

const iamSmartBtnStyle = makeStyles((theme) => ({
    root: {
        borderRadius: 6,
        backgroundColor: theme.palette.iamSmart.main,
        color: theme.palette.common.white,
        textTransform: "none",
        "&:hover": {
            backgroundColor: theme.palette.iamSmart.main,
        },
        height: "3rem",
        fontSize: "1.11em", // 37% of height, min 12px
        "@media (max-width: 500px)": {
            height: "3.5rem",
            fontSize: "1em", // 37% of height, min 12px
            minHeight: "3.5rem",
            minWidth: "14rem",
        },
    },
}));

export default function IamsmartLoginButton({
    onLogin,
    loginMsg = "",
    setLoginMsg = () => {},
}) {
    const dispatch = useDispatch();
    const { iamsmart } = useSelector(getIamsmart());

    const iamsmartProfile = useSelector(getIamsmartProfile());

    console.log("the value of iamsmartProfile ####", iamsmartProfile);

    const { t, i18n } = useTranslation();
    const [open, setOpen] = useState(false);
    const [authCode, setAuthCode] = useState("");
    const [ticketID, setTicketID] = useState("");
    const [qrLinkURL, SetQrLinkURL] = useState("");
    const [step, setStep] = useState("qrLink");
    const [openLinkUp, setOpenLinkUp] = useState(false);
    const [hasLinkUp, setHasLinkUp] = useState(false);
    const [openLoginSuccess, setOpenLoginSuccess] = useState(false);
    const [noSigning, setNoSigning] = useState(false);
    const [cookies, setCookie, removeCookie] = useCookies(["token"]);
    const [openID, setOpenID] = useState("");
    const [accountLocked, setAccountLocked] = useState(false);
    //const openID = getIamsmartOpenID();
    //const [userType, setUserType] = useState("");

    // const iamsmartProfile = useSelector(getIamsmartProfile());

    const handleClose = () => {
        setOpen(false);
        setAuthCode("");
        SetQrLinkURL("");
        // if (isObjectNotEmpty(iamsmartProfile)) {
        //     setOpenLinkUp(true);
        // }
        //setStep("qrLink");
    };

    const iamSmartBtnClasses = iamSmartBtnStyle();
    let winRef;
    // const iasContent = useSelector(getIamsmartContent());
    const getFromIamsmart = () => {
        //setOpen(true);
        //SetQrLinkURL("");
        const userAgent = navigator.userAgent;
        const headers = {
            clientEntityName: "edbeform",
            userAgent: navigator.userAgent,
            redirectURI: `https://${Config.DOMAIN}${Config.CONTENT_PATH}/iamsmartLogin`,
            language: t("common.iamsmart.lang"),
        };
        const headersV20 = {
            userAgent: userAgent,
            lang: t("common.iamsmart.lang"),
            redirectURI: `https://${Config.DOMAIN}${Config.CONTENT_PATH}/iamsmartLogin`,
            //redirectURI: `https://192.168.1.102:3000/eformss_v20/iamsmartLogin`,
        };
        const optionV20 = {
            url: "/iamsmartedbv2/edbeform/auth/prepare-init",
            method: "POST",
            header: headersV20,

            option: { redirect: "follow" },
        };
        winRef = window.open("", "_blank");
        var QRLink = dispatch(sendV20("GET_IAMSMART_PROFILE_QR", optionV20))
            .then((response) => response.text())
            .then((result) => {
                let strData = jwtDecode(result)?.data?.action;
                SetQrLinkURL(strData);
                // setTimeout(function () {
                //     winRef.location = strData;
                // }, 100);
                winRef.location = strData;
            })
            .catch((error) => {
                console.log("fetch error: ", error);
            });
    };

    const onGetProfile = () => {
        const clientEntityName = "edbeform";
        const userAgent = navigator.userAgent;
        const fields = "enName";
        const headers = {
            authCode: authCode,
            clientEntityName: "edbeform",
            userAgent: navigator.userAgent,
            fields: "enName",
        };
        const headersV20 = {
            code: authCode,
            isDirectLoginV2: false,
        };
        const option = {
            url: "/iamsmartedbv2/getTKID",
            method: "POST",
            header: headers,
        };

        const optionV20 = {
            url: "/iamsmartedbv2/edbeform/auth/response",
            method: "POST",
            header: headersV20,
        };

        dispatch(sendV20("GET_IAMSMART_PROFILE", optionV20))
            .then((response) => response.json())
            .then((result) => {
                result = jwtDecode(result)?.data;
                console.log("getTKID Result: ", result);
                if (
                    result.error ||
                    //result.userType != "sign"
                    (result.userType != "sign" && result.userType != "default")
                ) {
                    setOpen(true);
                    setNoSigning(true);
                    setStep("getProfileResult");
                } else {
                    dispatch(
                        getIamsmartProfileDone(
                            result.accessToken,
                            result.openID,
                            "" //result.ticketID
                        )
                    );
                    console.log("the ####", iamsmart);
                    console.log("the ####", iamsmart);
                    console.log("the ####", iamsmart);
                    handleClose();
                    const option = {
                        url: `${Config.CONTENT_PATH}/iamsmartLoginByOpenID`,
                        method: "POST",
                        body: JSON.stringify({ openID: result.openID }),
                    };
                    console.log("result: ", result);
                    setOpenID(result.openID);
                    //dispatch(setOpenID(result.openID));
                    setAccountLocked(false);
                    dispatch(send("IAMSMART_LOGIN", option))
                        .then((response) => response.json())
                        .then((loginResult) => {
                            if (loginResult.msg === "ACCOUNT_LOCKED") {
                                setAccountLocked(true);
                                setLoginMsg("");
                            } else if (loginResult.linked) {
                                setCookie("token", loginResult.token, {
                                    path: `${Config.CONTENT_PATH}`,
                                    maxAge: 3600,
                                    secure: true,
                                });
                                dispatch(setToken(loginResult));
                                dispatch(setUserRole(loginResult.role));
                                setHasLinkUp(true);
                                setOpenLoginSuccess(true);
                            } else {
                                setOpenLinkUp(true);

                                // for iamsmart "no plus" login (userType = "default")
                                // if (result.userType === "default") {
                                //     setOpen(true);
                                //     setNoSigning(true);
                                //     setStep("getProfileResult");
                                // } else {
                                //     setOpenLinkUp(true);
                                // }
                            }
                        });
                }
            });
    };

    const channel = "IamsmartLogin";

    const openApp = () => {
        console.log(ticketID, getIamsmartAppUrl(ticketID, "eme"));
        window.open(getIamsmartAppUrl(ticketID, "eme"));
    };

    if (isIOS()) {
        window.addEventListener("storage", function (e) {
            if (e.key == channel) {
                const query = new URLSearchParams(e.newValue);
                console.log("query", query);
                //setStep("getProfile");
                setAuthCode(query.get("code"));
            }
        });
    }

    useEffect(() => {
        if (isNotEmpty(qrLinkURL)) {
            if (!isIOS()) {
                console.log("sysend is listening...");
                sysend.on(channel, (data) => {
                    console.log("recieved data from other tab: ", data);
                    const query = new URLSearchParams(data);
                    setAuthCode(query.get("code"));
                });
            }
            return () => {
                console.log("Stop listening from other tab");
                if (!isIOS()) sysend.off(channel);
            };
        }
    }, [qrLinkURL]);

    useEffect(() => {
        if (isNotEmpty(authCode)) {
            onGetProfile();
        }
    }, [authCode]);

    useEffect(() => {
        if (loginMsg === "ACCOUNT_LOCKED") {
            setAccountLocked(false);
        }
    }, [loginMsg]);

    const onCancel = () => {
        setStep("qrLink");
        setOpen(false);
    };

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "90%",
        height: "90%",
        bgcolor: "white",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };
    if (Config.ENABLE_IAMSMART != "true") return <></>;
    else
        return (
            <>
                <Button
                    variant="contained"
                    classes={{ root: iamSmartBtnClasses.root }}
                    startIcon={
                        <img
                            className="iamSmartPhone"
                            src={iamSmartPhone}
                            alt=""
                            width="20px"
                        />
                    }
                    className="iamSmartButton"
                    onClick={getFromIamsmart}
                    style={
                        i18n.language === "en"
                            ? { width: "100%", minWidth: "14rem" }
                            : { width: "100%", minWidth: "10rem" }
                    }
                >
                    <div
                        style={
                            i18n.language === "en"
                                ? { width: "14rem", minWidth: "10rem" }
                                : { width: "10rem", minWidth: "10rem" }
                        }
                    >
                        {t("common.iamsmart.logo")}
                    </div>
                </Button>
                {
                    // dummy testing
                }
                <InputLabel htmlFor="iamSmartInput" style={{ display: "none" }}>
                    {t("common.iamsmart.logo")}
                </InputLabel>
                <CustomTextField
                    onChange={(e) => {
                        setTicketID(e.target.value);
                    }}
                    id="iamSmartInput"
                    style={{ display: "none" }}
                />
                <Button
                    variant="contained"
                    classes={{ root: iamSmartBtnClasses.root }}
                    startIcon={
                        <img
                            className="iamSmartPhone"
                            src={iamSmartPhone}
                            alt=""
                        />
                    }
                    className="iamSmartButton"
                    onClick={openApp}
                    style={
                        i18n.language === "en"
                            ? { width: "12rem", display: "none" }
                            : { display: "none" }
                    }
                >
                    <div style={{ fontSize: "12px" }}>
                        {t("common.iamsmart.logo")}
                    </div>
                </Button>

                <LinkUpDialog
                    open={openLinkUp}
                    openID={openID}
                    onLinkUp={() => {
                        setOpenLinkUp(false);
                        setOpenLoginSuccess(true);
                    }}
                    onClose={() => {
                        setOpenLinkUp(false);
                    }}
                />
                <Dialog
                    // onClose={handleClose}
                    aria-labelledby="simple-dialog-title"
                    open={openLoginSuccess}
                >
                    <DialogTitle id="simple-dialog-title">
                        {t("common.iamsmart.login.success")}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {hasLinkUp && t("common.iamsmart.login.success")}
                            {!hasLinkUp &&
                                t("common.iamsmart.linkup.linkupSuccess")}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onLogin}>
                            {t("common.iamsmart.confirm")}
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    BackdropComponent={Backdrop}
                >
                    {step == "qrLink" && (
                        <>
                            <DialogContent>
                                <DialogContentText>
                                    {t("common.iamsmart.authen.title")}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={onCancel}>
                                    {t("common.iamsmart.authen.cancel")}
                                </Button>
                            </DialogActions>
                        </>
                    )}
                    {step == "getProfile" && (
                        <>
                            <DialogTitle>
                                {t("common.iamsmart.linkup.sectionTitle")}
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    {t("common.iamsmart.linkup.description")}
                                </DialogContentText>
                                <DialogContentText>
                                    <ul>
                                        {t("common.iamsmart.linkup.criteria", {
                                            returnObjects: true,
                                        }).map((criteria, index) => (
                                            <li key={index}>{criteria}</li>
                                        ))}
                                    </ul>
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                {!noSigning && (
                                    <Button
                                        variant="contained"
                                        classes={{
                                            root: iamSmartBtnClasses.root,
                                        }}
                                        startIcon={
                                            <img
                                                className="iamSmartPhone"
                                                src={iamsmartIconDark}
                                                alt="i am smart icon"
                                            />
                                        }
                                        className="iamSmartButton"
                                        onClick={onGetProfile}
                                    >
                                        <div style={{ fontSize: "12px" }}>
                                            {t(
                                                "common.iamsmart.linkup.provideDataToIamsmart"
                                            )}
                                        </div>
                                    </Button>
                                )}

                                {noSigning && (
                                    <Typography style={{ color: "red" }}>
                                        {t("common.iamsmart.noSigning")}
                                    </Typography>
                                )}
                                <Button onClick={onCancel}>
                                    {t("common.iamsmart.linkup.cancel")}
                                </Button>
                            </DialogActions>
                        </>
                    )}
                    {step == "getProfileResult" && (
                        <>
                            <DialogContent>
                                <DialogContentText>
                                    {/*<ol>
                                    {t("common.iamsmart.authen.step", {
                                        returnObjects: true,
                                    }).map((criteria, index) => {
                                        if (index === 0) {
                                            return (
                                                <>
                                                    <li key={index}>
                                                        <Typography
                                                            style={{
                                                                color: "#2B7366",
                                                            }}
                                                        >
                                                            {criteria}
                                                        </Typography>
                                                    </li>
                                                    <img
                                                        src={iamsmartTap}
                                                        alt={"i am smart icon"}
                                                        style={{
                                                            width: "100px",
                                                        }}
                                                    />
                                                </>
                                            );
                                        }
                                        return <li key={index}>{criteria}</li>;
                                    })}
                                </ol>*/}
                                    {noSigning && (
                                        <Typography style={{ color: "red" }}>
                                            {t("common.iamsmart.noSigning")}
                                        </Typography>
                                    )}
                                </DialogContentText>
                            </DialogContent>
                        </>
                    )}
                </Dialog>
                {accountLocked && (
                    <FormHelperText>
                        <ErrorMsg
                            message={t("common.login.error.accountLocked")}
                        />
                    </FormHelperText>
                )}
            </>
        );
}
